// extracted by mini-css-extract-plugin
module.exports = {"card":"c_c","red":"c_d","blue":"c_f","green":"c_g","yellow":"c_h","orange":"c_j","violet":"c_k","title":"c_l"};